'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
class NavigationBlock {
    static toSearchNavigationItems(...blocks) {
        return blocks == null ? void 0 : blocks.map((block)=>block ? block.categories.map((category)=>category.items.map((item)=>_extends({}, item, {
                        hint: category.title
                    }))).flat() : []).flat();
    }
}

export { NavigationBlock };
//# sourceMappingURL=Navigation.js.map
